import React from 'react'
import { BannerType, useBannerContext } from 'src/context/Banner/BannerContext'
import { Banner } from './Banner'

export const AuditUploadReminderBanner = (): JSX.Element => {
  const { banners, dismissBanner } = useBannerContext()
  const auditUploadReminderBanner = banners[BannerType.AUDIT_UPLOAD_REMINDER]
  const showDateLimitBanner = auditUploadReminderBanner?.showBanner

  if (!showDateLimitBanner) return <></>

  return (
    <Banner
      text={auditUploadReminderBanner.message}
      link={auditUploadReminderBanner.link}
      isWarning={auditUploadReminderBanner.isWarning}
      onDismiss={() => dismissBanner(BannerType.AUDIT_UPLOAD_REMINDER)}
    />
  )
}
